import {Map, List} from 'immutable';
import React from 'react';
import {connect} from 'react-redux';
import * as actionCreators from './actions';
import NumberInput from '../NumberInput/NumberInput';
import {VelocityTransitionGroup} from 'velocity-react';

export class PartyDetailsRoom extends React.Component {

    constructor(props) {
        super();
        this.state = {...props};
    }



    setTravellerValue(type) {
        return number => {
            this.props.setTravellerValue(type, number, this.props.index);
        };
    }

    setChildAge(roomIndex, childIndex) {
        return age => {
          this.props.setChildAge(roomIndex, childIndex, age);
        };
    }

    render() {
        return (
        <div className={'party-details-room'}>
            {/*<div className={'party-details-room__title'}>Apartment / room {this.props.index+1}</div>*/}
            <div className={'party-details-room__room-container'}>
                <div className={'party-details__number-input-container cf'}>
                    <NumberInput callback={this.setTravellerValue('adults')} divClass={'party-details__number-input'}
                                 hideArrows={true} minValue={1} value={this.props.adults} step={1} label={'Adults (18+)'}
                                 name={`Rooms[${this.props.index}].Adults`}
                                 id={`party-details__number-of-adults${this.props.index}`}/>
                    <NumberInput callback={this.setTravellerValue('children')} value={this.props.children}
                                 divClass={'party-details__number-input'}
                                 name={`Rooms[${this.props.index}].Children`}
                                 runOnActualChange={true}
                                 hideArrows={true} minValue={0} maxValue={10} label={'Children'}
                                 id={`party-details__number-of-children=${this.props.index}`}/>
                </div>

                {this.props.children > 0 ?
                    (<div>
                        <div className={'party-details-room__age-title'}>Children's ages on date of return travel.</div>
                        <VelocityTransitionGroup
                            className={'party-details-room__transition-group'}
                            enter={{animation: {scale: 1, opacity: 1}}}
                            runOnMount={true}
                            leave={{animation: {scale: 0, opacity: 0}}}>
                            {[...Array(this.props.children)].map((x, i) => {
                                const age = this.props.childAges.getIn([i, 'age'], '');
                                return (
                                    <NumberInput key={`child-age${i}`}
                                                 divClass={'party-details__number-input --full-width'}
                                                 hideArrows={true} minValue={0} placeholder={'Age in years'}
                                                 defaultValue={age}
                                                 maxValue={17}
                                                 integersOnly={true}
                                                 label={`Child ${i + 1} age`}
                                                 name={`Rooms[${this.props.index}].ChildAge[${i}]`}
                                                 allowEmpty={true}
                                                 runOnActualChange={true}
                                                 callback={this.setChildAge(this.props.index, i).bind(this)}
                                                 id={`party-details__child-age-${this.props.index}-${i}`}/>);
                            })}
                        </VelocityTransitionGroup>
                    </div>) : null}
            </div>
        </div>
        );
    }
}

export default connect((stateMap, ownProps) => {
    const state = stateMap.get('partyDetails', Map({}));
    return {
        index: ownProps.index,
        children: state.getIn(['rooms', ownProps.index, 'children'], 0),
        childAges: state.getIn(['rooms', ownProps.index, 'childAges'], List([])),
        adults: state.getIn(['rooms', ownProps.index, 'adults'], 2)
    };
}, actionCreators)(PartyDetailsRoom);
